module.exports = __webpack_public_path__ + "static/media/preview_user_referrals.f4f9dc81.png";